import Swal from "sweetalert2";

import {
  CREATE_PR_SUCCESS,
  CREATE_PR_REJECTED,
  apiUrl,
  CREATE_PR_FETCH,
  UPDATE_PR_FETCH,
  UPDATE_PR_SUCCESS,
  UPDATE_PR_REJECTED,
  GET_PR_FETCH,
  GET_PR_SUCCESS,
  GET_PR_REJECTED,
  LIST_PR_FETCH,
  LIST_PR_SUCCESS,
  LIST_PR_REJECTED,
  ADD_PRODUCT_REJECTED,
  ADD_PRODUCT_SUCCESS,
  DELETE_PRODUCT_SUCCESS,
  DELETE_PRODUCT_REJECTED,
  GET_PR_EXPENSE_FETCH,
  GET_PR_EXPENSE_SUCCESS,
  GET_PR_EXPENSE_REJECTED,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_EXPENSE_REJECTED,
  UPDATE_PR_CLEAR,
  ADD_PRODUCT_CLEAR,
  CREATE_PR_DETAIL_REMARK_SUCCESS,
  CREATE_PR_DETAIL_REMARK_REJECTED,
  CREATE_PR_DETAIL_REMARK_CLEAR,
  LIST_PR_DETAIL_REMARK_FETCH,
  LIST_PR_DETAIL_REMARK_SUCCESS,
  LIST_PR_DETAIL_REMARK_REJECTED,
  DELETE_PR_DETAIL_REMARK_SUCCESS,
  DELETE_PR_DETAIL_REMARK_REJECTED,
  DELETE_PR_DETAIL_REMARK_CLEAR,
  LIST_SUPPLIER_FETCH,
  LIST_SUPPLIER_SUCCESS,
  LIST_SUPPLIER_REJECTED,
  LIST_YEAR_FETCH,
  LIST_YEAR_SUCCESS,
  LIST_YEAR_REJECTED,
  LIST_PR_JOB_FETCH,
  LIST_PR_JOB_SUCCESS,
  LIST_PR_JOB_REJECTED,
  GET_PR_JOB_FETCH,
  GET_PR_JOB_SUCCESS,
  GET_PR_JOB_REJECTED,
  LIST_ASSIGNER_FETCH,
  LIST_ASSIGNER_SUCCESS,
  LIST_ASSIGNER_REJECTED,
  GET_PR_JOB_ITEM_FETCH,
  GET_PR_JOB_ITEM_SUCCESS,
  GET_PR_JOB_ITEM_REJECTED,
  ADD_DETAIL_REMARK_JOB_SUCCESS,
  ADD_DETAIL_REMARK_JOB_CLEAR,
  ADD_DETAIL_REMARK_JOB_REJECTED,
  LIST_DETAIL_REMARK_JOB_FETCH,
  LIST_DETAIL_REMARK_JOB_SUCCESS,
  LIST_DETAIL_REMARK_JOB_REJECTED,
  REMOVE_DETAIL_REMARK_JOB_SUCCESS,
  REMOVE_DETAIL_REMARK_JOB_CLEAR,
  REMOVE_DETAIL_REMARK_JOB_REJECTED,
  GET_COUNTRIES_FETCH,
  GET_COUNTRIES_SUCCESS,
  GET_COUNTRIES_REJECTED,
  GET_PR_EXPENSE_JOB_FETCH,
  GET_PR_EXPENSE_JOB_SUCCESS,
  GET_PR_EXPENSE_JOB_REJECTED,
  GET_REMARK_STATUS_FETCH,
  GET_REMARK_STATUS_SUCCESS,
  GET_REMARK_STATUS_REJECTED,
} from "src/Constants";

import { httpClient } from "src/utils/HttpClient";

export const getPurchaseDetails = (id) => {
  return (dispatch) => {
    dispatch({ type: "get_purchase_detail_fetch" });
    httpClient
      .get(`/purchase-request/purchase-detail/${id}`)
      .then((response) => {
        dispatch({
          type: "get_purchase_detail_success",
          payload: response.data,
        });
      })
      .catch((err) => {
        dispatch({ type: "get_purchase_detail_rejected" });
      });
  };
};

export const getYearList = () => {
  return async (dispatch) => {
    dispatch({
      type: LIST_YEAR_FETCH,
    });
    try {
      const result = await httpClient.get(`/refs/year-list`);
      dispatch({
        type: LIST_YEAR_SUCCESS,
        payload: result.data,
      });
    } catch (err) {
      dispatch({ type: LIST_YEAR_REJECTED });
    }
  };
};

export const updatePurchaseExpense = (value, history) => {
  const { PREXIDX, PRHIDX } = value;

  return (dispatch) => {
    return httpClient
      .put(`${apiUrl}/purchase-request/purchase-expense/${PREXIDX}`, value)
      .then((result) => {
        dispatch({
          type: UPDATE_EXPENSE_SUCCESS,
          payload: result.data.message,
        });
        Swal.fire({
          text: result.data.message,
          icon: result.data.icon,
        }).then(() => {
          dispatch(getPurchaseRequestById(PRHIDX));
          if (result.data.icon === "success") {
            history.goBack();
          }
        });
      })
      .catch((err) => {
        dispatch({ type: UPDATE_EXPENSE_REJECTED });
        Swal.fire({
          text: err.message,
          icon: "error",
        });
      });
  };
};

export const getAllFiles = (id) => {
  return (dispatch) => {
    dispatch({ type: "get_attach_files_fetch" });
    return httpClient
      .get(`${apiUrl}/purchase-request/attach-files/${id}`)
      .then((response) => {
        dispatch({ type: "get_attach_files_success", payload: response.data });
      })
      .catch((err) => {
        dispatch({ type: "get_attach_files_rejected" });
      });
  };
};

export const deleteFiles = (id, headerId) => {
  return (dispatch) => {
    return httpClient
      .delete(`${apiUrl}/purchase-request/attach-files/${id}`)
      .then((res) => {
        dispatch(getAllFiles(headerId));
      });
  };
};

export const updatePurchaseExpenseJob = (value, history) => {
  const { PREXIDX } = value;

  return (dispatch) => {
    return httpClient
      .put(`${apiUrl}/purchase-request/purchase-expense/${PREXIDX}`, value)
      .then((result) => {
        dispatch({
          type: UPDATE_EXPENSE_SUCCESS,
          payload: result.data.message,
        });
        Swal.fire({
          text: result.data.message,
          icon: "success",
        }).then(() => {
          history.goBack();
        });
      })
      .catch((err) => {
        dispatch({ type: UPDATE_EXPENSE_REJECTED });
      });
  };
};

export const getPurchaseExpense = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_PR_EXPENSE_FETCH });
    return httpClient
      .get(`/purchase-request/purchase-expense/${id}/1`)
      .then((result) => {
        dispatch({ type: GET_PR_EXPENSE_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_PR_EXPENSE_REJECTED });
      });
  };
};

export const getPurchaseExpenseJob = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_PR_EXPENSE_JOB_FETCH });
    return httpClient
      .get(`/purchase-request/purchase-expense/${id}/2`)
      .then((result) => {
        dispatch({ type: GET_PR_EXPENSE_JOB_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: GET_PR_EXPENSE_JOB_REJECTED });
      });
  };
};

export const getPurchaseRequestAdmin = () => {
  return (dispatch) => {
    dispatch({ type: LIST_PR_FETCH });
    return httpClient
      .get(`${apiUrl}/purchase-request/admin`)
      .then((result) => {
        dispatch({ type: LIST_PR_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_PR_REJECTED });
      });
  };
};

export const getPurchaseRequestStaff = (countryid) => {
  return (dispatch) => {
    dispatch({ type: LIST_PR_FETCH });
    return httpClient
      .get(`${apiUrl}/purchase-request/staff/${countryid}`)
      .then((result) => {
        dispatch({ type: LIST_PR_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_PR_REJECTED });
      });
  };
};

export const getPurchaseRequestUser = (brandid, departid, countryid) => {
  return (dispatch) => {
    dispatch({ type: LIST_PR_FETCH });
    return httpClient
      .get(
        `${apiUrl}/purchase-request/user/${brandid}/${departid}/${countryid}`
      )
      .then((result) => {
        dispatch({ type: LIST_PR_SUCCESS, payload: result.data });
      })
      .catch((err) => {
        dispatch({ type: LIST_PR_REJECTED });
      });
  };
};

export const getPurchaseRequestById = (id) => {
  return async (dispatch) => {
    dispatch({ type: GET_PR_FETCH });
    try {
      const { data } = await httpClient.get(`${apiUrl}/purchase-request/${id}`);
      const prSuppliers = await httpClient.get(
        `/purchase-request/pr-suppliers?prhidx=${id}`
      );

      dispatch({
        type: GET_PR_SUCCESS,
        payload: data,
      });

      dispatch({
        type: "GET_PR_SUPPLIERS_SUCCESS",
        payload: prSuppliers.data,
      });
    } catch (err) {
      dispatch({ type: GET_PR_REJECTED });
    }
  };
};

export const getPurchaseRequestPrintById = (id) => {
  return (dispatch) => {
    dispatch({ type: GET_PR_FETCH });
    httpClient
      .get(`${apiUrl}/purchase-request/purchase-print?id=${id}`)
      .then(({ data }) => {
        dispatch({ type: GET_PR_SUCCESS, payload: data });
      })
      .catch(() => {
        dispatch({ type: GET_PR_REJECTED });
      });
  };
};

export const createPurchaseRequest = (
  countryid,
  fullname,
  companyid,
  currencyid,
  brand_id,
  depart_id,
  created_id,
  created_email,
  created_secid,
  history
) => {
  return (dispatch) => {
    dispatch({ type: CREATE_PR_FETCH });
    return httpClient
      .post(`${apiUrl}/purchase-request/create`, {
        countryid: countryid,
        create_by: fullname,
        companyid: companyid,
        currencyid: currencyid,
        brand_id: brand_id,
        depart_id: depart_id,
        created_id: created_id,
        created_secid: created_secid,
        created_email: created_email,
      })
      .then((result) => {
        const {
          result: { PRHIDX },
          message,
        } = result.data;
        dispatch({ type: CREATE_PR_SUCCESS, payload: message });
        history.push(`/edit-purchase-requisition/${PRHIDX}`);
      })
      .catch(() => {
        dispatch({ type: CREATE_PR_REJECTED });
      });
  };
};

export const updatePurchaseRequest = (id, values, history = null) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PR_FETCH });
    return httpClient
      .put(`${apiUrl}/purchase-request/update/${id}`, values)
      .then(async (result) => {
        dispatch(getPurchaseRequestById(id));

        dispatch({ type: UPDATE_PR_SUCCESS, payload: result.data.message });

        if (history) {
          dispatch(getPurchaseExpense(id, 1));

          if (values.PR_STATUS === 40) {
            Swal.fire({
              text: "The purchase requesition has rejected.",
              icon: "success",
            }).then(() => {
              dispatch({ type: UPDATE_PR_CLEAR });
              history.goBack();
            });
          }

          if (values.PR_STATUS === 0) {
            Swal.fire({
              text: "The purchase requesition has canceled.",
              icon: "success",
            }).then(() => {
              dispatch({ type: UPDATE_PR_CLEAR });
              history.goBack();
            });
          }

          if (values.PR_STATUS === 20) {
            const { value } = result.data;
            let messages = "";
            if (value.REF_CODE) {
              messages = `The reference Code : ${value.REF_CODE} has been sent an email.`;
              Swal.fire({
                text: messages,
                icon: "success",
              }).then(() => {
                dispatch({ type: UPDATE_PR_CLEAR });
              });
            } else {
              Swal.fire({
                text: result.data.message,
                icon: "success",
              }).then(() => {
                dispatch({ type: UPDATE_PR_CLEAR });
              });
            }
          }

          if (values.PR_STATUS === 30) {
            Swal.fire({
              text: "The purchase requesition has approved.",
              icon: "success",
            }).then(() => {
              dispatch({ type: UPDATE_PR_CLEAR });
              history.goBack();
            });
          }

          if (values.PR_STATUS === 50) {
            httpClient
              .get(`/purchase-request/receive-job/${id}`, values)
              .then(() => {
                Swal.fire({
                  text: result.data.message,
                  icon: "success",
                }).then(() => {
                  dispatch({ type: UPDATE_PR_CLEAR });
                  history.push(`/purchase-edit-job/${id}`);
                });
              })
              .catch((err) => {
                dispatch({ type: UPDATE_PR_REJECTED });
                Swal.fire({
                  title: "Error !",
                  text: err.message,
                  icon: "error",
                });
              });
          }

          if (values.PR_STATUS === 10) {
            Swal.fire({
              text: result.data.message,
              icon: "success",
            }).then(() => {
              dispatch({ type: UPDATE_PR_CLEAR });
            });
          }
        }
      })
      .catch((err) => {
        dispatch({ type: UPDATE_PR_REJECTED });
        Swal.fire({
          title: "Error !",
          text: err.message,
          icon: "error",
        });
      });
  };
};

export const contractPurchaseUpdate = (id, values, history = null) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PR_FETCH });
    return httpClient
      .put(`${apiUrl}/purchase-request/contract-update/${id}`, values)
      .then(async (result) => {
        dispatch(getPurchaseRequestById(id));
        dispatch({ type: UPDATE_PR_SUCCESS, payload: result.data.message });
      })
      .catch((err) => {
        dispatch({ type: UPDATE_PR_REJECTED });
        Swal.fire({
          title: "Error !",
          text: err.message,
          icon: "error",
        });
      });
  };
};

export const addProduct = (
  values,
  departid,
  brandid,
  yearcode,
  companyid,
  status,
  headerData
) => {
  let _method = "POST";
  let _endpoint = "create-detail";
  if (values.PRDIDX) {
    _method = "PUT";
    _endpoint = `update-detail/${values.PRDIDX}`;
  }
  return (dispatch) => {
    if (values.BUDGETP_CODE) {
      return httpClient
        .get(
          `/purchase-request/budget-balance-project/${values.BGIDX}/${values.PR_DEPARTID}/${values.PR_BRANDID}/${yearcode}/${companyid}/${values.BUDGETP_CODE}`
        )
        .then((result) => {
          if (result.data) {
            const { FINAL_BAL } = result.data;
            let BudgetBalance = 0;
            if (values.OLD_AMOUNT) {
              BudgetBalance = FINAL_BAL + values.OLD_AMOUNT - values.AMOUNT;
            } else {
              BudgetBalance = FINAL_BAL - values.AMOUNT;
            }
            if (BudgetBalance >= 0) {
              httpClient({
                method: _method,
                url: `${apiUrl}/purchase-request/${_endpoint}`,
                data: values,
              })
                .then(() => {
                  dispatch({ type: ADD_PRODUCT_SUCCESS });

                  Swal.fire({
                    text: "Added the item successfully.",
                    icon: "success",
                  }).then(() => {
                    const { PRHIDX } = headerData;
                    if (status === 5) {
                      headerData.PR_STATUS = 10;
                      dispatch(updatePurchaseRequest(PRHIDX, headerData, null));
                    }
                    dispatch(getPurchaseDetails(PRHIDX));
                    dispatch({ type: ADD_PRODUCT_CLEAR });
                  });
                })
                .catch((err) => {
                  dispatch({
                    type: ADD_PRODUCT_REJECTED,
                    payload: "",
                  });
                  Swal.fire({
                    title: "Error !",
                    text: "There was error while adding the product, Try again.",
                    icon: "error",
                  });
                });
            } else {
              Swal.fire({
                title: "Warning !",
                text: "Please consider your budget!",
                icon: "warning",
              });
            }
          } else {
            Swal.fire({
              title: "Warning !",
              text: "the budget is not found!",
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ADD_PRODUCT_REJECTED,
            payload: "",
          });
          Swal.fire({
            title: "Error !",
            text: "Connot add the product item!",
            icon: "error",
          });
        });
    } else {
      return httpClient
        .get(
          `/purchase-request/budget-balance/${values.BGIDX}/${values.PR_DEPARTID}/${values.PR_BRANDID}/${yearcode}/${companyid}`
        )
        .then((result) => {
          if (result.data) {
            const { FINAL_BAL } = result.data;
            let BudgetBalance = 0;
            if (values.OLD_AMOUNT) {
              BudgetBalance = FINAL_BAL + values.OLD_AMOUNT - values.AMOUNT;
            } else {
              BudgetBalance = FINAL_BAL - values.AMOUNT;
            }
            if (BudgetBalance >= 0) {
              httpClient({
                method: _method,
                url: `${apiUrl}/purchase-request/${_endpoint}`,
                data: values,
              })
                .then(() => {
                  dispatch({ type: ADD_PRODUCT_SUCCESS });
                  Swal.fire({
                    text: "Added the item successfully.",
                    icon: "success",
                  }).then(() => {
                    const { PRHIDX } = headerData;
                    if (status === 5) {
                      headerData.PR_STATUS = 10;
                      dispatch(updatePurchaseRequest(PRHIDX, headerData, null));
                    }
                    dispatch(getPurchaseDetails(PRHIDX));
                    dispatch({ type: ADD_PRODUCT_CLEAR });
                  });
                })
                .catch((err) => {
                  dispatch({
                    type: ADD_PRODUCT_REJECTED,
                    payload: "",
                  });
                  Swal.fire({
                    title: "Error !",
                    text: "There was error while adding the product, Try again.",
                    icon: "error",
                  });
                });
            } else {
              Swal.fire({
                title: "Warning !",
                text: "Please consider your budget!",
                icon: "warning",
              });
            }
          } else {
            Swal.fire({
              title: "Warning !",
              text: "the budget is not found!",
              icon: "warning",
            });
          }
        })
        .catch((err) => {
          dispatch({
            type: ADD_PRODUCT_REJECTED,
            payload: "",
          });
          Swal.fire({
            title: "Error !",
            text: "Connot add the product item!",
            icon: "error",
          });
        });
    }
  };
};

export const deleteProduct = (id) => {
  return (dispatch) => {
    return httpClient
      .delete(`/purchase-request/delete-detail/${id}`)
      .then((result) => {
        const { message } = result.data;
        dispatch({ type: DELETE_PRODUCT_SUCCESS, payload: message });
      })
      .catch((err) => {
        dispatch({
          type: DELETE_PRODUCT_REJECTED,
          payload:
            "Connot delete the product item. Maybe the product item was not found!",
        });
      });
  };
};

export const saveRemarkDetail = (value) => {
  let _method = "POST";
  let _endpoint = "detail-remark";
  if (value.ID) {
    _method = "PUT";
    _endpoint = `detail-remark/${value.ID}`;
  }

  return (dispatch) => {
    return httpClient({
      method: _method,
      url: `/purchase-request/${_endpoint}`,
      data: value,
    })
      .then((resultSave) => {
        dispatch({
          type: CREATE_PR_DETAIL_REMARK_SUCCESS,
        });
        Swal.fire({
          text: "The remark was successfully added.",
          icon: "success",
        }).then(() => {
          const { PRDIDX } = value;
          dispatch(getRemarkDetail(PRDIDX));

          dispatch({
            type: CREATE_PR_DETAIL_REMARK_CLEAR,
          });
        });
      })
      .catch((error) => {
        dispatch({
          type: CREATE_PR_DETAIL_REMARK_REJECTED,
          payload: "There was error while saving the remark, Try again.",
        });
        Swal.fire({
          title: "Error !",
          text: "There was error while saving the remark, Try again.",
          icon: "error",
        });
      });
  };
};

export const getRemarkDetail = (id) => {
  return async (dispatch) => {
    dispatch({ type: LIST_PR_DETAIL_REMARK_FETCH });
    try {
      const result = await httpClient.get(
        `/purchase-request/detail/detail-remark/${id}`
      );
      dispatch({ type: LIST_PR_DETAIL_REMARK_SUCCESS, payload: result.data });
      return result.data;
    } catch (err) {
      dispatch({ type: LIST_PR_DETAIL_REMARK_REJECTED });
    }
  };
};

export const deleteRemarkDetail = (id, detailId) => {
  return async (dispatch) => {
    try {
      const result = await httpClient.delete(
        `/purchase-request/detail-remark/${id}`
      );
      const { message } = result.data;

      dispatch({ type: DELETE_PR_DETAIL_REMARK_SUCCESS, payload: message });
      dispatch(getRemarkDetail(detailId));

      dispatch({ type: DELETE_PR_DETAIL_REMARK_CLEAR });
    } catch (err) {
      dispatch({
        type: DELETE_PR_DETAIL_REMARK_REJECTED,
        payload: "Connot delete the product remark!",
      });
    }
  };
};

export const getPurchaseRequestJobs = (countryid) => {
  return async (dispatch) => {
    dispatch({ type: LIST_PR_JOB_FETCH });
    try {
      const result = await httpClient.get(
        `/purchase-request/job-list/${countryid}`
      );
      dispatch({ type: LIST_PR_JOB_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: LIST_PR_JOB_REJECTED });
    }
  };
};

export const getPurchaseRequestJobAdmin = (countryid) => {
  return async (dispatch) => {
    dispatch({ type: LIST_PR_JOB_FETCH });
    try {
      const result = await httpClient.get(`/purchase-request/job-list-admin`);
      dispatch({ type: LIST_PR_JOB_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: LIST_PR_JOB_REJECTED });
    }
  };
};

export const getPurchaseRequesitionJobById = (id) => {
  return async (dispatch) => {
    dispatch({ type: GET_PR_JOB_FETCH });
    try {
      const result = await httpClient.get(`/purchase-request/job/${id}`);
      dispatch({ type: GET_PR_JOB_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_PR_JOB_REJECTED });
    }
  };
};

export const getJobItemById = (id) => {
  return async (dispatch) => {
    dispatch({ type: GET_PR_JOB_ITEM_FETCH });
    try {
      const result = await httpClient.get(`/purchase-request/job-byid/${id}`);
      dispatch({ type: GET_PR_JOB_ITEM_SUCCESS, payload: result.data });
    } catch (err) {
      dispatch({ type: GET_PR_JOB_ITEM_REJECTED });
    }
  };
};

export const getSupplier = (company_code) => {
  return async (dispatch) => {
    dispatch({ type: LIST_SUPPLIER_FETCH });
    try {
      // const result = await httpClient.get(`/purchase-request/suppliers`);
      const result = await httpClient.get(`/refs/suppliers/${company_code}`);
      dispatch({ type: LIST_SUPPLIER_SUCCESS, payload: result.data });
    } catch (error) {
      dispatch({
        type: LIST_SUPPLIER_REJECTED,
      });
    }
  };
};

export const addSupplier = (id, values, headerId) => {
  return (dispatch) => {
    return httpClient({
      method: "PUT",
      url: `${apiUrl}/purchase-request/update-detail/${id}`,
      data: values,
    })
      .then(() => {
        dispatch({ type: ADD_PRODUCT_SUCCESS });
        dispatch(getPurchaseRequesitionJobById(headerId));
      })
      .catch((err) => {
        dispatch({
          type: ADD_PRODUCT_REJECTED,
          payload: "",
        });
        Swal.fire({
          title: "Error !",
          text: "There was error while adding the supplier, Try again.",
          icon: "error",
        });
      });
  };
};

export const addSupplierJob = (id, values, headerId) => {
  return (dispatch) => {
    return httpClient({
      method: "PUT",
      url: `${apiUrl}/purchase-request/update-job-detail/${id}`,
      data: values,
    })
      .then(() => {
        dispatch({ type: ADD_PRODUCT_SUCCESS });
        dispatch(getPurchaseRequesitionJobById(headerId));
      })
      .catch((err) => {
        dispatch({
          type: ADD_PRODUCT_REJECTED,
          payload: "",
        });
        Swal.fire({
          title: "Error !",
          text: "There was error while adding the supplier, Try again.",
          icon: "error",
        });
      });
  };
};

export const updateJobItem = (id, values, history) => {
  return (dispatch) => {
    return httpClient({
      method: "PUT",
      url: `${apiUrl}/purchase-request/update-job-detail/${id}`,
      data: values,
    })
      .then(() => {
        dispatch({ type: ADD_PRODUCT_SUCCESS });
        Swal.fire({
          text: `Updated : ${values.ITEMS_DETAIL}`,
          icon: "success",
        }).then(() => {
          history.goBack();
        });
      })
      .catch((err) => {
        dispatch({
          type: ADD_PRODUCT_REJECTED,
          payload: "",
        });
        Swal.fire({
          title: "Error !",
          text: "There was error while adding the supplier, Try again.",
          icon: "error",
        });
      });
  };
};

export const addProductJob = (
  values,
  departid,
  brandid,
  yearcode,
  companyid,
  history
) => {
  let _method = "POST";
  let _endpoint = "create-job-detail";
  if (values.PRJIDX) {
    _method = "PUT";
    _endpoint = `update-job-detail/${values.PRJIDX}`;
  }

  return (dispatch) => {
    if (values.BUDGETP_CODE) {
      return httpClient
        .get(
          `/purchase-request/budget-balance-project/${values.BGIDX}/${departid}/${brandid}/${yearcode}/${companyid}/${values.BUDGETP_CODE}`
        )
        .then((result) => {
          if (result.data) {
            const { FINAL_BAL } = result.data;

            let BudgetBalance = 0;

            if (values.OLD_AMOUNT) {
              BudgetBalance = FINAL_BAL + values.OLD_AMOUNT - values.AMOUNT;
            } else {
              BudgetBalance = FINAL_BAL - values.AMOUNT;
            }

            if (BudgetBalance >= 0) {
              httpClient({
                method: _method,
                url: `${apiUrl}/purchase-request/${_endpoint}`,
                data: values,
              })
                .then(() => {
                  dispatch({ type: ADD_PRODUCT_SUCCESS });
                  Swal.fire({
                    text: "The item was successfully saved.",
                    icon: "success",
                  }).then(() => {
                    history.goBack();
                  });
                })
                .catch((err) => {
                  dispatch({
                    type: ADD_PRODUCT_REJECTED,
                    payload: "",
                  });
                  Swal.fire({
                    title: "Error !",
                    text: "There was error while adding the product, Try again.",
                    icon: "error",
                  });
                });
            } else {
              dispatch({
                type: ADD_PRODUCT_REJECTED,
                payload: "",
              });

              Swal.fire({
                title: "Warning !",
                text: "Please consider your budget!",
                icon: "warning",
              });
            }
          } else {
            Swal.fire({
              title: "Warning !",
              text: "the budget is not found!",
              icon: "warning",
            });
          }
          dispatch({ type: ADD_PRODUCT_CLEAR });
        })
        .catch((err) => {
          dispatch({
            type: ADD_PRODUCT_REJECTED,
            payload: "",
          });
          Swal.fire({
            title: "Error !",
            text: "Connot add the product item!",
            icon: "error",
          });
        });
    } else {
      return httpClient
        .get(
          `/purchase-request/budget-balance/${values.BGIDX}/${departid}/${brandid}/${yearcode}/${companyid}`
        )
        .then((result) => {
          if (result.data) {
            const { FINAL_BAL } = result.data;

            let BudgetBalance = 0;

            if (values.OLD_AMOUNT) {
              BudgetBalance = FINAL_BAL + values.OLD_AMOUNT - values.AMOUNT;
            } else {
              BudgetBalance = FINAL_BAL - values.AMOUNT;
            }

            if (BudgetBalance >= 0) {
              httpClient({
                method: _method,
                url: `${apiUrl}/purchase-request/${_endpoint}`,
                data: values,
              })
                .then(() => {
                  dispatch({ type: ADD_PRODUCT_SUCCESS });
                  Swal.fire({
                    text: "The item was successfully saved.",
                    icon: "success",
                  }).then(() => {
                    history.goBack();
                  });
                })
                .catch((err) => {
                  dispatch({
                    type: ADD_PRODUCT_REJECTED,
                    payload: "",
                  });
                  Swal.fire({
                    title: "Error !",
                    text: "There was error while adding the product, Try again.",
                    icon: "error",
                  });
                });
            } else {
              dispatch({
                type: ADD_PRODUCT_REJECTED,
                payload: "",
              });

              Swal.fire({
                title: "Warning !",
                text: "Please consider your budget!",
                icon: "warning",
              });
            }
          } else {
            Swal.fire({
              title: "Warning !",
              text: "the budget is not found!",
              icon: "warning",
            });
          }
          dispatch({ type: ADD_PRODUCT_CLEAR });
        })
        .catch((err) => {
          dispatch({
            type: ADD_PRODUCT_REJECTED,
            payload: "",
          });
          Swal.fire({
            title: "Error !",
            text: "Connot add the product item!",
            icon: "error",
          });
        });
    }
  };
};

export const updateProductJob = (
  values,
  departid,
  brandid,
  yearcode,
  companyid,
  history
) => {
  return (dispatch) => {
    httpClient({
      method: "PUT",
      url: `${apiUrl}/purchase-request/update-job-detail/${values.PRJIDX}`,
      data: values,
    })
      .then(() => {
        dispatch({ type: ADD_PRODUCT_SUCCESS });
        Swal.fire({
          text: "The item was successfully saved.",
          icon: "success",
        }).then(() => {
          history.goBack();
        });
      })
      .catch((err) => {
        dispatch({
          type: ADD_PRODUCT_REJECTED,
          payload: "",
        });
        Swal.fire({
          title: "Error !",
          text: "There was error while adding the product, Try again.",
          icon: "error",
        });
      });
  };
};

export const getAssignees = (id) => {
  return async (dispatch) => {
    dispatch({ type: LIST_ASSIGNER_FETCH });
    try {
      const result = await httpClient.get(`/purchase-request/assignees/${id}`);
      dispatch({ type: LIST_ASSIGNER_SUCCESS, payload: result.data });
    } catch (error) {
      dispatch({
        type: LIST_ASSIGNER_REJECTED,
      });
    }
  };
};

export const getRemarkJob = (id) => {
  return (dispatch) => {
    dispatch({
      type: LIST_DETAIL_REMARK_JOB_FETCH,
    });

    return httpClient
      .get(`/purchase-request/detail-remark-job/${id}`)
      .then((result) => {
        dispatch({
          type: LIST_DETAIL_REMARK_JOB_SUCCESS,
          payload: result.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: LIST_DETAIL_REMARK_JOB_REJECTED,
        });
      });
  };
};

export const saveRemarkJob = (value) => {
  let _method = "POST";
  let _endpoint = "detail-remark-job";
  if (value.ID) {
    _method = "PUT";
    _endpoint = `detail-remark-job/${value.ID}`;
  }

  return (dispatch) => {
    return httpClient({
      method: _method,
      url: `/purchase-request/${_endpoint}`,
      data: value,
    })
      .then(() => {
        dispatch({
          type: ADD_DETAIL_REMARK_JOB_SUCCESS,
        });
        Swal.fire({
          text: "The remark was successfully added.",
          icon: "success",
        }).then(() => {
          const { PRJIDX } = value;
          dispatch(getRemarkJob(PRJIDX));

          dispatch({
            type: ADD_DETAIL_REMARK_JOB_CLEAR,
          });
        });
      })
      .catch((error) => {
        dispatch({
          type: ADD_DETAIL_REMARK_JOB_REJECTED,
        });
      });
  };
};

export const deleteRemarkJob = (id, headerId) => {
  return (dispatch) => {
    return httpClient
      .delete(`/purchase-request/detail-remark-job/${id}`)
      .then(() => {
        dispatch({
          type: REMOVE_DETAIL_REMARK_JOB_SUCCESS,
        });
        dispatch(getRemarkJob(headerId));
        dispatch({
          type: REMOVE_DETAIL_REMARK_JOB_CLEAR,
        });
      })
      .catch((error) => {
        dispatch({
          type: REMOVE_DETAIL_REMARK_JOB_REJECTED,
        });
      });
  };
};

export const getCountries = (countryid) => {
  return (dispatch) => {
    dispatch({
      type: GET_COUNTRIES_FETCH,
    });
    return httpClient
      .get(`/purchase-request/countries/${countryid}`)
      .then((result) => {
        dispatch({
          type: GET_COUNTRIES_SUCCESS,
          payload: result.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_COUNTRIES_REJECTED,
        });
      });
  };
};

export const getRemarkStatus = (id) => {
  return (dispatch) => {
    dispatch({
      type: GET_REMARK_STATUS_FETCH,
    });
    return httpClient
      .get(`/purchase-request/remark-status/${id}`)
      .then((result) => {
        dispatch({
          type: GET_REMARK_STATUS_SUCCESS,
          payload: result.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: GET_REMARK_STATUS_REJECTED,
        });
      });
  };
};

export const verifyPr = (id, value, history) => {
  return (dispatch) => {
    dispatch({ type: UPDATE_PR_FETCH });
    return httpClient
      .put(`${apiUrl}/purchase-request/verify-purchase/${id}`, value)
      .then(async (result) => {
        dispatch({ type: UPDATE_PR_SUCCESS, payload: result.data.message });
        Swal.fire({
          text: "The purchase requisition has been successful.",
          icon: "success",
        });
        history.push(`/purchase-edit-job/${id}`);
      })
      .catch((err) => {
        dispatch({ type: UPDATE_PR_REJECTED });
        Swal.fire({
          title: "Error !",
          text: err.message,
          icon: "error",
        });
      });
  };
};
